import { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { getRegulationInfos } from 'state/quotes/regulations/regulation.selectors';
import { getQuoteIsCostsAndChargesRequired } from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

import { CostsAndChargesRegulatoryComponent } from './Regulatory.costsandcharges';

export const CostsAndChargesRegulatory: FC<
  PropsWithChildren<{
    tabId: string;
    quoteId: string;
    workspaceType: QuoteWorkspaceType;
  }>
> = ({ tabId, quoteId }) => {
  const regulationInfos = useSelector((state: AppState) => getRegulationInfos(state, tabId, quoteId));
  const isCostsAndChargesRequired = useSelector((state: AppState) => getQuoteIsCostsAndChargesRequired(state, tabId));

  const costsAndCharges = regulationInfos?.costAndCharge;

  const hasEmptyCostAndCharge = (regulationInfos?.costAndCharge?.length ?? 0) === 0;
  const isCostsAndChargesVisible =
    !(regulationInfos?.costAndChargeReceived && hasEmptyCostAndCharge) && isCostsAndChargesRequired;

  const isLoading = regulationInfos?.costAndChargeReceived !== true;

  return (
    <CostsAndChargesRegulatoryComponent
      isCostsAndChargesRequired={isCostsAndChargesVisible}
      costsAndChargesWithNotional={costsAndCharges}
      isLoading={isLoading}
    />
  );
};
